import * as types from "../constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";
import {editorOriginMatches, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";

const initialState = {
    instanceId: null,
    template: {
        templateKey: "",
        name: "",
        nameQualifier: null,
        description: "",
        script: "",
        metadata: {},
        groupKeys: [],
        showGroupKeys: []
    },
    groupKeys: [],
    options: {
        hasScript: false,
        hasDescription: false,
        validate: [],
        isValidating: false
    }
};

export default function categoryEditorReducer(state = initialState, action) {
    let addGroup;
    let newState;
    switch (action.type) {
        case types.CATEGORY_EDITOR_INITIALIZE:
            return {
                ...state,
                ...action.payload
            };

        case types.CATEGORY_EDITOR_UPDATE:
            return {
                ...state,
                template: {
                    ...state.template,
                    ...action.payload.template
                },
                options: {
                    ...state.options,
                    ...action.payload.options
                }
            };

        case types.CATEGORY_EDITOR_CLEAR:
            return {
                ...initialState
            };

        case types.CATEGORY_EDITOR_ADD_GROUP:// eslint-disable-line no-case-declarations

            let cloneCategory = portalShared.cloneObj(state.template);
            cloneCategory.groupKeys = cloneCategory.groupKeys.includes(action.groupKey) ? cloneCategory.groupKeys : [...cloneCategory.groupKeys, action.groupKey];

            //return cloneCategory;

            addGroup = [
                ...state.groupKeys,
                action.groupKey
            ];
            return {
                ...state,
                template: cloneCategory,
                groupKeys: addGroup
            };

        case types.GROUP_TEMPLATE_CREATE_SUCCESS:
            if (!editorOriginMatches(action.origin, EDITOR_TYPES.CATEGORY, state)) {
                return state;
            }
            addGroup = [
                ...state.groupKeys,
                action.groupTemplate.templateKey
            ];
            return {
                ...state,
                groupKeys: addGroup
            };

        case types.CATEGORY_EDITOR_REMOVE_GROUP:// eslint-disable-line no-case-declarations

            newState = portalShared.cloneObj(state);

            let removedGroupKey = state.groupKeys[action.index];

            newState.template.groupKeys = newState.template.groupKeys.filter(key => key !== removedGroupKey);

            let removeGroup = state.groupKeys.filter((element, index) => {
                return index !== action.index;
            });

            newState.groupKeys = removeGroup;

            return newState;

        case types.CATEGORY_EDITOR_REORDER:// eslint-disable-line no-case-declarations
            let groupKeys = [...state.groupKeys];
            let target = (action.isUp)? -1 : 1;
            target = target + action.currentIndex;

            if (target < 0) { target=0;}
            else if (target > groupKeys.length -1) {target = groupKeys.length -1;}

            let removed = groupKeys.splice(action.currentIndex, 1);
            groupKeys.splice(target, 0, removed[0]);
            return {
                ...state,
                groupKeys
            };

        case types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_EXISTS:
            return {
                ...state,
                options: {
                    ...state.options,
                    validate: action.list,
                    isValidating: false
                }
            };
        case types.CATEGORY_EDITOR_NAME_AND_QUALIFIER_VALIDATING:
            return {
                ...state,
                options: {
                    ...state.options,
                    isValidating: true
                }
            };

        case types.CATEGORY_EDITOR_ADD_SHOW_GROUP_KEYS:

            newState = portalShared.cloneObj(state);

            for (let i = 0; i < action.showGroupKeys.length; i++) {
                if (!newState.template.showGroupKeys.includes(action.showGroupKeys[i])) {
                    newState.template.showGroupKeys.push(action.showGroupKeys[i]);
                }
            }

            return newState;

        case types.CATEGORY_EDITOR_SET_SHOW_GROUP_KEYS:

            newState = portalShared.cloneObj(state);

            newState.template.groupKeys = newState.template.groupKeys.filter(key => key !== action.removedGroupKey);
            
            newState.template.showGroupKeys = action.showGroupKeys;

            return newState;

        default:
            return state;
    }
}
